<template>
  <div v-if="visible" class="loader-overlay">
    <div class="spim-loader-container" :class="{'is-loading': visible}">
    <div class="spim-loader">
      <div class="spim-loader__rhombus-1"></div>
      <div class="spim-loader__rhombus-2"></div>
      <div class="spim-loader__rhombus-3"></div>
      <div class="spim-loader__rhombus-4"></div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped>
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader {
  border: 16px solid #f3f3f3;
  border-top: 16px solid #3498db;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>